/* Copyright 2013 The MathWorks, Inc. */

define([
    "dojo/_base/declare",
    "dojo/dom-class",
    "dojo/dom-geometry",
    "dojo/dom-construct",
    "dojo/query",
    "dijit/registry"
], function (declare, domClass, domGeom, domConstruct, query, registry) {

    return declare([], {
        constructor: function (manager) {
            this.manager = manager;
            this.construct();
        },

        construct: function () {
            var originalNode, cloneNode, originalNodePos, cloneItemWrapperNode, avatarNode, galleryPopupWidget,
                favCategoryWidget, favItemWidget;

            // Since we only support dragging one element at a time, it is safe to just pick the first
            originalNode = this.manager.nodes[0];

            // Clone the gallery item node where the drag was started from
            cloneNode = originalNode.cloneNode(true);

            // Get the height and width of the original gallery item
            originalNodePos = domGeom.position(originalNode);

            // Apply the height and width to the clone node, this is particularly important for the list view
            cloneNode.style.width = originalNodePos.w + "px";
            cloneNode.style.height = originalNodePos.h + "px";
            

            cloneItemWrapperNode = query(".itemWrapper", cloneNode)[0];

            // Widget of the item that is being dragged
            favItemWidget = registry.getEnclosingWidget(originalNode);
            favCategoryWidget = favItemWidget.getParent();
            galleryPopupWidget = registry.byId(favCategoryWidget.get("galleryPopupId"));

            // Apply the same classes to the avatar node as the gallery popup in order to inherit the same styles
            avatarNode = domConstruct.create("div", {
                'class': galleryPopupWidget.domNode.getAttribute("class")
            });

            // We don't need the galleryPopup class styles on the avatar node
            domClass.remove(avatarNode, "galleryPopup");

            avatarNode.style.position = "absolute";
            avatarNode.style.zIndex = "1999";
            avatarNode.opacity = 0.7;
            

            // Remove the default classes applied by dojo from the clone node
            domClass.remove(cloneNode, "dojoDndItemOver dojoDndItem dojoDndItemAnchor");
            domClass.add(cloneNode, "galleryItemAvatar");

            domClass.remove(cloneItemWrapperNode);
            domClass.add(cloneItemWrapperNode, "itemWrapper");

            domConstruct.place(cloneNode, avatarNode);

            this.node = avatarNode;
        },

        destroy: function () {
            domConstruct.destroy(this.node);
            this.node = false;
        },

        update: function () {
            domClass.toggle(this.node, "dojoDndAvatarCanDrop", this.manager.canDropFlag);
        }
    });

});
